import { render, staticRenderFns } from "./SignPropertyEditor.vue?vue&type=template&id=6e0f5cfc&scoped=true&"
import script from "./SignPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./SignPropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0f5cfc",
  null
  
)

export default component.exports